import React from 'react';
import { createRoot } from 'react-dom/client';
import { isContainerLoadedInDOM } from '../../../lib/utilities';

export const renderToDomFactory = container => component => {
    if (!isContainerLoadedInDOM(container)) {
        TYROOLA.root[container.id] = createRoot(container);
    }
    return TYROOLA.root[container.id].render(component);
};
